import Axios from 'axios';
import { empresasLead } from './bff/bffClient';
import { mapCelularLead } from './bff/bffMappers';
import { getPathName, getPais, Pais, getApiHash, getApiToken } from './helper';

type ContactoCelularParams = {
    origen?: string;
    rubro?: string;
    isMobile?: boolean;
    tipoCotizador?: string;
    landingUrl?: string;
    refererUrl?: string;
    nombre?: string;
    apellido?: string;
    codigoArea?: string;
    telefono: {
        prefijo?: string;
        numero?: string;
    }
    email?: string;
    token?: string;
    captchaToken: string;
    parametrosIniciales: {
        origen?: string,
    };
    /** País real del build (lo pasa el form desde config.pais); default getPais(). */
    pais?: Pais;
};

/**
 * Lead Celular. ROUTING POR PAÍS (el BFF es Argentina-only):
 * - AR: body tipado §12.2 (`mapCelularLead`) al BFF. personType=PHYSICAL.
 * - UY: flujo LEGACY al monolito (POST {monolito}/SetCotizacionCelularJSON).
 * El país lo determina `params.pais` o `getPais()`.
 * Devuelve el envelope { data: { api_status, api_data } }.
 */
const guardarContactoCelular = async (params: ContactoCelularParams) => {
    const origen = params.parametrosIniciales?.origen ?? params.origen;
    const pais = params.pais ?? getPais();

    if (pais === 'UY') {
        const data: Record<string, any> = {
            origen: origen,
            isMobile: "false",
            landingUrl: params.landingUrl,
            refererUrl: params.refererUrl,
            rubro: "CELULAR",
            hash: await getApiHash(),
            nombre: params.nombre,
            apellido: params.apellido,
            codigoArea: params.telefono.prefijo ?? null,
            telefono: params.telefono.numero ?? null,
            email: params.email ?? null,
            RefererUrl: params.landingUrl,
            g_recaptcha_response: params.captchaToken,
        };
        const headers = {
            'content-type': 'application/json',
            "Authorization": 'Bearer ' + await getApiToken(),
        };
        return await Axios.post(await getPathName() + "/SetCotizacionCelularJSON", data, { headers })
            .then((response) => response)
            .catch((error) => error);
    }

    const body = mapCelularLead({
        origen,
        landingUrl: params.landingUrl ?? (typeof window !== 'undefined' ? window.location.href : undefined),
        refererUrl: params.refererUrl,
        nombre: params.nombre,
        apellido: params.apellido,
        codigoArea: params.telefono.prefijo,
        telefono: params.telefono.numero,
        email: params.email,
    });

    try {
        const apiData = await empresasLead(body);
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        return error;
    }
};

export default guardarContactoCelular;
